import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import IMask from 'imask';
import { useFirebase } from 'react-redux-firebase'

import { Cross } from '../UI/Cross'
import { colors } from '../../styles/colors'
import { ConsultationButton } from '../UI/ConsultationButton'
import { getStringWithUpperFirstChar } from '../../functions/getStringWithUpperFirstChar'

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: auto;

    position: fixed;
    top: 0:
    left: 0;
    z-index: 10;
    background: rgba(255, 255, 255, 0.5);

    padding: 2rem;

    @media (min-width: 768px) {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .cross-button {
        top: 3rem;
        right: 3rem;
    }
    .popup {
        max-width: 940px;
        padding: 2.5rem 12.5rem 5rem 12.5rem;
        background: ${colors.dark_blue};
        box-shadow: -16px 16px 6px rgba(0, 0, 0, 0.4);

        position: relative;

        @media (min-width: 321px) and (max-width: 767.98px) {
            padding: 10rem 5rem;
        }
        @media (max-width: 320px) {
            padding: 10rem 2rem;
        }
    }
    .title,
    .thanks-text {
        max-width: 500px;
        font-family: 'SF UI Text',sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        line-height: 160%;
        color: ${colors.white};
        margin-bottom: 3.75rem;
    }
    .thanks-text {
        text-align: center;
        margin: 4rem 0;
    }
    .inputs {
        display: flex;
        margin-bottom: 5rem;

        @media (max-width: 767.98px) {
            flex-direction: column;
        }
    }
    .first-block {
        display: flex;
        flex-direction: column;
    }
    input {
        width: 100%;
        height: 55px;
        color: ${colors.dark_blue};

        padding-left: 2.5rem; 

        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        outline: none;

        :not(:last-child) {
            margin-bottom: 3.75rem;
        }

        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }

        @media (max-width: 767.98px) {
            flex-direction: column;
            margin-bottom: 3.75rem;

        }
    }
    textarea {
        width: 100%;
        height: 100%;
        margin-left: 7.5rem;
        outline: none;
        padding: 2.5rem;

        font-family: 'SF UI Text',sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        color: ${colors.dark_blue};

        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }

        @media (max-width: 767.98px) {
            flex-direction: column;
            margin: 0;
        }

    }

    .consultation-button {
        width: 200px;
        margin: 0 auto;
    }
    .agreement {
        font-family: 'SF UI Text',sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;
        color: ${colors.white};

        margin: 3rem auto;

        a {
            color: ${colors.white};
            transition: all .5s;

            :hover {
                color: ${colors.red};
            }
        }
    }
`

export const ConsultationForm = () => {

    const db = useFirebase()
    const dispatch = useDispatch()

    const [formSubmited, setFormSubmited] = useState(false)
    const [submitDisabled, setSubmitDisabled] = useState(true)

    const main_data = useSelector(state => state.firebase.data.main_data )   

    const [name, setName] = useState('')
    const [tel, setTel] = useState('')
    const [email, setEmail] = useState('')
    const [description, setDescription] = useState('')

    function checkDataAcceptChangeAvailable() {
        const formated_name = name.trim().replace(/\s{2,}/g, ' ')
        const formated_email = email.trim().replace(/\s{2,}/g, ' ')

        if (
            (formated_name.length !== 0) && (tel.length === 16) && (formated_email.length !== 0)
        ) {
            setSubmitDisabled(false)
        } else {
            setSubmitDisabled(true)
        }

    }

    useEffect(() => {
        let maskOptions = {
            mask: '+{7}(000)000-00-00'
        };
        const tel_input = document.querySelector('input[type="tel"]')
        if (tel_input) {
            // let mask = IMask(tel_input, maskOptions);
            IMask(tel_input, maskOptions);

        }

        checkDataAcceptChangeAvailable()
    })

    function handleSubmit() {
        const data = {
            name,
            tel,
            email,
            description,
            status: 'new'
        }

        // Put data in database
        db.ref('orders').push(data)

        // Prepare data and sent to mail.php
        
        const order_data = {
            to: main_data.email_for_orders,
            title: 'Заявка на Консультацию',
            tel,
            name,
            email,
            description,
            order: 'Консультация'
        }

        fetch('./mail.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(order_data),
        }).then(() => setFormSubmited(true))
        
    }
    function handleClose() {
        dispatch({ type: 'CONSULTATION_FORM_CLOSED' })
        setFormSubmited(false)
    }


    return (
        <Container>
            <div className="popup">
                <div className="cross-container" onClick={() => handleClose()}>
                    <Cross lighten />
                </div>
                {formSubmited
                    ? (
                        <>
                            <p className='thanks-text'>Спасибо за заявку!</p>
                            <p className='thanks-text'>Наш менеджер свяжется с Вами в ближайшее время :{`)`}</p>
                        </>
                    )
                    : (
                        <>
                            <p className="title">Чтобы получить консультацию, заполните форму для заявки!</p>
                            <div className="inputs">
                                <div className="first-block">
                                    <input type="text" value={getStringWithUpperFirstChar(name)} placeholder='ФИО*' onChange={e => setName(e.target.value)} required />
                                    <input type="tel" value={tel} placeholder="+7 (___) ___ __-__ *" onChange={e => setTel(e.target.value)} required />
                                    <input type="email" value={email} placeholder='Эл.адрес*' onChange={e => setEmail(e.target.value)} required />
                                </div>
                                <div className="second-block">
                                    <textarea value={description} placeholder='Комментарий' onChange={e => setDescription(e.target.value)} ></textarea>
                                </div>
                            </div>
                            <div className="agreement">
                                <p>Отправляя данные Вы автоматически соглашаетесь с</p>
                                { main_data 
                                        ? <a href={main_data.privacy_policy} target="_blank" rel="noopener noreferrer" >Политикой конфиденциальности</a> 
                                        : <p>Политикой конфиденциальности</p>
                                    }
                            </div>
                            <div className="submit-button"  >
                                <ConsultationButton disabled={submitDisabled} onclick={()=> handleSubmit()} lighten />
                            </div>
                        </>
                    )
                }

            </div>
        </Container>
    )
}
